import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Icon from '../common/icons/Icon';
import { Modal } from 'synfrastructure';
import AddForm from '../common/forms/AddForm';
import { fetchSection, createLibraryRecord, updateSectionName, reorderLibraryVideos } from './actions';
import { SubmissionError } from 'redux-form';
import { formatValidationErrors } from '../common/utils/getApiReducer';
import Breadcrumb from '../common/components/Breadcrumb';
import Loading from '../common/components/Loading';
import SortableListWrapper from '../common/components/SortableListWrapper';

import { selectActiveCategory, selectActiveSection } from './selectors';

class SectionDetailPage extends Component {
  static propTypes = {
    category: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      addVideoModalVisible: false,
    };
  }

  componentDidMount() {
    const { match, dispatch } = this.props;

    dispatch(fetchSection(match.params.categoryId, match.params.sectionId));
  }

  toggleAddVideoModal = () => {
    this.setState(state => ({ addVideoModalVisible: !state.addVideoModalVisible }));
  };

  toggleEditNameModal = () => {
    this.setState(state => ({ editNameModalVisible: !state.editNameModalVisible }));
  };

  onAddVideoSubmit = name => {
    const { dispatch, match } = this.props;

    return dispatch(createLibraryRecord(match.params.categoryId, match.params.sectionId, name)).then(action => {
      if (!action.response.ok) {
        throw new SubmissionError(formatValidationErrors(action.json).toJS());
      } else {
        this.props.history.push(
          `/library/${match.params.categoryId}/sections/${match.params.sectionId}/videos/${action.json.id}`
        );
      }
    });
  };

  onEditNameSubmit = name => {
    const { dispatch, match } = this.props;

    return dispatch(updateSectionName(match.params.categoryId, match.params.sectionId, name)).then(action => {
      if (!action.response.ok) {
        throw new SubmissionError(formatValidationErrors(action.json).toJS());
      } else {
        this.toggleEditNameModal();
      }
    });
  };

  render() {
    const { activeCategory, activeSection, dispatch, loaded, match } = this.props;
    const { addVideoModalVisible, editNameModalVisible } = this.state;

    if (!loaded) {
      return <Loading />;
    }

    const breadcrumbs = [
      {
        label: 'Library',
        to: '/library',
      },
      {
        label: activeCategory.get('name'),
        to: `/library/${match.params.categoryId}`,
      },
      {
        label: activeSection.name,
        to: null,
      },
    ];

    const libraryRecords = activeSection.libraryRecords;

    let renderedSections =
      libraryRecords && libraryRecords.length ? (
        libraryRecords.map(record => {
          return (
            <li key={`record-${record.id}`}>
              <div className="admin-paper__list__title">{record.name}</div>
              <div className="admin-paper__list__actions">
                <Link to={`/library/${match.params.categoryId}/sections/${match.params.sectionId}/videos/${record.id}`}>
                  <Icon icon="Pencil" />
                </Link>
              </div>
            </li>
          );
        })
      ) : (
        <div className="admin-paper__no-content">No videos found</div>
      );

    return (
      <div>
        <div className="admin-paper">
          <Modal isVisible={addVideoModalVisible} onClose={this.toggleAddVideoModal}>
            <AddForm
              entityType="Video"
              initialValues={{ name: null }}
              onSubmit={this.onAddVideoSubmit}
              onCancel={this.toggleAddVideoModal}
            />
          </Modal>
          <Modal isVisible={editNameModalVisible} onClose={this.toggleEditNameModal}>
            <AddForm
              action="Edit"
              entityType="Section"
              initialValues={{ name: activeSection.name }}
              onSubmit={this.onEditNameSubmit}
              onCancel={this.toggleEditNameModal}
            />
          </Modal>
          <div className="admin-paper__header">
            <Breadcrumb crumbs={breadcrumbs} />
            <button onClick={this.toggleAddVideoModal} className="admin__add-button">
              <Icon icon="Plus" /> Add Video
            </button>
          </div>
          <div className="admin-paper__edit-content">
            <div>
              <div className="admin-paper__edit-content__row">
                <p>Section Name</p>
                <span className="title">{activeSection.name}</span>
              </div>
              <div className="admin-paper__edit-button">
                <button className="button" onClick={this.toggleEditNameModal}>
                  Edit
                </button>
              </div>
            </div>
          </div>
        </div>
        <SortableListWrapper
          items={libraryRecords}
          onSave={items => {
            return dispatch(
              reorderLibraryVideos(match.params.categoryId, match.params.sectionId, {
                videoIds: items.map(section => section.id),
              })
            );
          }}
          title="Videos"
        >
          <ul className="admin-paper__list">{renderedSections}</ul>
        </SortableListWrapper>
      </div>
    );
  }
}

export default connect((state, ownProps) => {
  const activeCategory = selectActiveCategory(state.library.categories, ownProps.match.params.categoryId);

  return {
    activeSection: selectActiveSection(state),
    loaded: state.library.activeSection.get('loaded'),
    activeCategory,
  };
})(SectionDetailPage);



// WEBPACK FOOTER //
// ./src/library/SectionDetailPage.js